import { useTranslationHelper } from '@shared/hooks/useTranslationsHelper';
import styles from './IRISPaymentHistory.module.css';

import {
  MdcBox,
  MdcCard,
  MdcCardContent,
  MdcChip,
  MdcGrid,
  MdcIcon,
  MdcIconButton,
  MdcList,
  MdcListItem,
  MdcMenu,
  MdcMenuAnchor,
  MdcTypography
} from 'ids-wc/dist/react/components';
import { ChipStatusColors, IRISPaymentHistoryItem } from './models/IRISPaymentHistoryDTO.model';
import { NO_VALUE_DASH } from '@shared/constants/no-value-dash';
import { formatProvider } from '@shared/helpers/format-provider.helper';
import { useRef } from 'react';

interface IRIPaymentHisoryItemProps {
  payment: IRISPaymentHistoryItem;
  onSelect: (data: string) => void;
}

export const ListItem = (props: IRIPaymentHisoryItemProps) => {
  const { t } = useTranslationHelper('IRISPaymentHistory');

  const menuRef = useRef<HTMLMdcMenuElement>(null);

  const { payment, onSelect } = props;

  const { debtorNo, amount, status, institution, paymentDate, rfcode, type } = payment;

  const toggleMenu = () => {
    if (menuRef.current) {
      menuRef.current.open();
    }
  };

  return (
    <MdcCard background="surface-1" className={styles['iris-payment-history-list-item']}>
      <MdcCardContent>
        <MdcGrid row>
          <MdcGrid col={2} alignSelf="center">
            <MdcTypography text={paymentDate} textAlign="left" variant="body2" color="textPrimary" />
          </MdcGrid>

          <MdcGrid col={2} alignSelf="center">
            <MdcChip
              label={status ? t(status) : NO_VALUE_DASH}
              size="sm"
              type="tag"
              variant="filled"
              color={ChipStatusColors[status]}
            />
          </MdcGrid>

          <MdcGrid col={2} alignSelf="center">
            <MdcTypography text={t(type)} textAlign="left" variant="body2" color="textPrimary" />
          </MdcGrid>

          <MdcGrid col={2} alignSelf="center">
            <MdcTypography
              text={formatProvider(institution.description)}
              textAlign="left"
              variant="body2"
              color="textPrimary"
            />
          </MdcGrid>

          <MdcGrid col={2} alignSelf="center">
            <MdcBox display="flex" alignItems="center">
              <MdcTypography
                variant="body2"
                color="textPrimary"
                text={rfcode}
                textAlign="right"
                wordBreak="break-all"
              />
            </MdcBox>
          </MdcGrid>

          <MdcGrid col={1} alignSelf="center">
            <MdcBox display="flex" alignItems="center">
              <MdcIcon size="xs" icon="currency-euro" color="secondary" />
              <MdcTypography variant="body2" color="textPrimary" text={amount} textAlign="right" />
            </MdcBox>
          </MdcGrid>

          {debtorNo && (
            <MdcGrid col={1} alignSelf="center">
              <MdcMenuAnchor>
                <MdcIconButton
                  icon="more-vert"
                  color="textPrimary"
                  size="sm"
                  labelAria={t('amoNr')}
                  onClick={toggleMenu}
                />
                <MdcMenu ref={menuRef}>
                  <MdcList>
                    <MdcListItem text={t('checkAMONr')} onClick={() => onSelect(debtorNo)} />
                  </MdcList>
                </MdcMenu>
              </MdcMenuAnchor>
            </MdcGrid>
          )}
        </MdcGrid>
      </MdcCardContent>
    </MdcCard>
  );
};
